import { TunnelDataContext } from "../digital-journey/context/TunnelDataContext"
import { fetchAcceptanceDocumentTypes } from "../service/fetchAcceptanceDocumentTypes"
import { useContext } from "react"
import { useQuery } from "react-query"

export default function useFetchUploadDocumentTypes() {
  const { tunnelData } = useContext(TunnelDataContext)

  const { data: documentTypesOptions, isLoading: isLoadingDocumentTypes } = useQuery({
    queryKey: ["query-documentTypes"],
    queryFn: () => fetchAcceptanceDocumentTypes({ tunnelData })
  })

  return { documentTypesOptions, isLoadingDocumentTypes }
}
